import { Collapse, List, Space, Tooltip } from "antd";
import "./RecruitmentQuestionList.scss";
import { VideoCameraOutlined } from "@ant-design/icons";

const { Panel } = Collapse;

function navigate(id) {
  window.open(`/recruitment-questions/${id}`, "_blank", "noopener,noreferrer");
}

const difficultyColor = {
  简单: "green",
  中等: "#ff8800",
  困难: "red",
};

function RecruitmentQuestionList(props) {
  const list = props.list;

  return (
    <Collapse
      className="recruitment-question-list-collapse"
      defaultActiveKey={list.content.map((sub) => sub.subTitle)}
    >
      {list.content.map((sub) => (
        <Panel key={sub.subTitle} header={sub.subTitle}>
          <List
            dataSource={sub.questions}
            renderItem={(q) => (
              <List.Item style={{ padding: 16 }} onClick={() => navigate(q.id)}>
                <div style={{ width: "4rem" }}>
                  <strong>{q.id}.</strong>
                </div>
                <div style={{ flex: 1, flexShrink: 1, paddingRight: 4 }}>
                  <Space>
                    <strong>{q.title}</strong>
                    {q.has_video_solution && (
                      <Tooltip title="有视频解答">
                        <VideoCameraOutlined />
                      </Tooltip>
                    )}
                  </Space>
                </div>
                <div style={{ color: difficultyColor[q.difficulty] }}>
                  {q.difficulty}
                </div>
              </List.Item>
            )}
          />
        </Panel>
      ))}
    </Collapse>
  );
}

export default RecruitmentQuestionList;
